var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 67,
  height: 67,
  viewBox: "0 0 67 67",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.472 5.58337C18.062 5.58337 5.58325 18.09 5.58325 33.5C5.58325 48.91 18.062 61.4167 33.472 61.4167C48.9099 61.4167 61.4166 48.91 61.4166 33.5C61.4166 18.09 48.9099 5.58337 33.472 5.58337ZM33.4999 55.8334C21.1608 55.8334 11.1666 45.8392 11.1666 33.5C11.1666 21.1609 21.1608 11.1667 33.4999 11.1667C45.8391 11.1667 55.8332 21.1609 55.8332 33.5C55.8332 45.8392 45.8391 55.8334 33.4999 55.8334ZM32.7183 19.5417H32.8858C34.0024 19.5417 34.8958 20.435 34.8958 21.5517V34.2259L45.6995 40.6467C46.6766 41.205 46.9837 42.4613 46.3974 43.4105C45.8391 44.3596 44.6108 44.6388 43.6616 44.0805L32.0762 37.1292C31.2108 36.6267 30.7083 35.7055 30.7083 34.7284V21.5517C30.7083 20.435 31.6016 19.5417 32.7183 19.5417Z",
  fill: "#079D56"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clock.44a2a2ce6e1992f89fdedda89691dcf9.svg";